import { renderIsomorphicComponent, renderComponent } from "@quintype/framework/client/start";

import { pickComponent } from "../isomorphic/pick-component";
import LoadingIndicatorComponent from "../isomorphic/components/atoms/loading-indicator";
import BottomAnchorAd from "../isomorphic/components/atoms/AnchorAd";
import InterstitialAd from "../isomorphic/components/atoms/InterstitialAd";
import Header from "../isomorphic/components/layouts/header";
import Footer from "../isomorphic/components/layouts/footer";
import GdprPolicy from "../isomorphic/components/molecules/GdprPolicy";
import TopAd from "../isomorphic/components/molecules/TopAd";

export function preRenderApplication(store) {
  const hydrate = { hydrate: !global.qtLoadedFromShell };
  renderComponent(Header, "header", store, hydrate);
  renderComponent(Footer, "footer", store);
  renderComponent(LoadingIndicatorComponent, "loading-indicator", store);
}

// This is a separate file as everything from here on is hot reloaded when the app changes
export function renderApplication(store) {
  const hydrate = { hydrate: !global.qtLoadedFromShell };

  renderComponent(TopAd, "top-ad", store, hydrate);
  renderComponent(BottomAnchorAd, "anchor-ad-container", store, hydrate);
  renderComponent(InterstitialAd, "interstitial-ad", store, hydrate);
  renderComponent(GdprPolicy, "gdpr-policy", store, hydrate);
  renderIsomorphicComponent("container", store, pickComponent, hydrate);
}
